interface Props {
  headers: Record<string, string> | null | undefined;
}

// Renders a request/response header bundle as a compact key/value table.
// Falls back to a muted placeholder when there are no headers to show.
export function HeadersTable({ headers }: Props) {
  const entries = headers ? Object.entries(headers) : [];

  if (entries.length === 0) {
    return (
      <div className="rounded bg-[var(--co-bg)] p-3 text-xs text-[var(--co-muted)]">
        No headers
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded border border-[var(--co-border)]">
      <table className="w-full text-xs">
        <tbody>
          {entries.map(([key, value]) => (
            <tr
              key={key}
              className="border-b border-[var(--co-border)] last:border-b-0"
            >
              <td className="whitespace-nowrap px-3 py-1.5 align-top font-mono font-semibold text-[var(--co-text)]">
                {key}
              </td>
              <td className="px-3 py-1.5 break-all font-mono text-[var(--co-muted)]">
                {value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
